import { useState } from 'react';

export function useToggle(initialState) {
    const [toggleState, setToggleState] = useState(initialState);

    function toggle() {
        setToggleState(!toggleState);
    }

    return [toggleState, toggle];
}
